import { ContractDefinition } from "./ContractDefinition";

export class AddEditDefinitionDialogDataModel {
  action: string;
  contractId: number;
  clientId: number;
  definitionId: number;
  definition: ContractDefinition;
}
